import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { useI18n } from '@design-system/i18n';
import { Image } from '@design-system/image';
import { useMatchBreakpoint } from '@design-system/theme';
import { Cover } from './Cover';
import { DefaultUserInformationWrapper } from './DefaultUserInformationWrapper';
import { GroupAndContentType } from './GroupAndContentType';
import { LikesAndCommentsIcons } from './LikesAndCommentsIcons';
import { LinkWrapper } from './LinkWrapper';
const DEFAULT_DISPLAY_FIELDS = {
    author: false,
    comments: false,
    content: false,
    contentType: false,
    group: false,
    likes: false,
};
const hasFooter = ({ author, comments, likes, }, displayFields = DEFAULT_DISPLAY_FIELDS) => (displayFields.author && author) ||
    (displayFields.comments && comments !== null && comments !== undefined) ||
    (displayFields.likes && likes !== null && likes !== undefined);
export const ForumPresentation = ({ UserInformationWrapper = DefaultUserInformationWrapper, contentTypeName, data: { author, comments, content, group, hasUncroppedName, imageSrc, likes, name, }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, withLink, }) => {
    const { __ } = useI18n();
    const isBreakpointMobile = useMatchBreakpoint('s');
    const isFooterVisible = hasFooter({ author, comments, likes }, displayFields);
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [Boolean(imageSrc) && (_jsx(CoverWrapper, { mr: { _: 0, m: 4 }, children: _jsx(Cover, { imageSrc: imageSrc, onClick: onClick, path: path, withLink: withLink }) })), _jsxs(Box, { alignSelf: { m: 'center' }, flexDirection: "column", width: "100%", children: [((displayFields.group && group) || displayFields.contentType) && (_jsx(GroupAndContentType, { group: displayFields.group ? group : undefined, type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('Forum')
                            : undefined })), _jsx(Box, { font: "h4-semibold", children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: hasUncroppedName ? (name) : (_jsx(Dotdotdot, { clamp: content && !isBreakpointMobile ? 1 : 2, children: name })) }) }), content && displayFields.content && (_jsx(Box, { mt: 1, children: _jsx(Dotdotdot, { clamp: isBreakpointMobile ? 2 : 1, screenReaderMaxLength: 150, children: content }) })), isFooterVisible && (_jsxs(Box, { alignItems: "center", justifyContent: "space-between", mt: 2, children: [_jsx(Box, { alignItems: "center", children: displayFields.author && author && (_jsx(UserInformationWrapper, { id: author.id, children: _jsxs(Box, { alignItems: "center", children: [_jsx(AvatarWrapper, { children: _jsx(LinkWrapper, { ariaLabel: __('Go to user %{name}').i__({
                                                        name: author.name,
                                                    }), path: author.path, tabIndex: -1, withLink: withLink, children: _jsx(Image, { alt: "", height: "100%", src: author.photoThumbUrl, style: { objectFit: 'cover' }, width: "100%" }) }) }), _jsx(Box, { children: _jsx(LinkWrapper, { font: "body-semibold-asphalt", path: author.path, withLink: withLink, children: author.name }) })] }) })) }), (displayFields.comments || displayFields.likes) && (_jsx(LikesAndCommentsIcons, { comments: comments, displayComments: displayFields.comments, displayLikes: displayFields.likes, likes: likes }))] }))] })] }));
};
const CoverWrapper = styled(Box).attrs(() => ({
    height: '98px',
    width: '186px',
    mb: { _: 4, m: 0 },
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
  flex-shrink: 0;
`;
const AvatarWrapper = styled(Box).attrs({
    height: '32px',
    mr: 2,
    width: '32px',
}) `
  border-radius: 50%;
  overflow: hidden;
`;
//# sourceMappingURL=ForumPresentation.js.map